import React from 'react';

/**
 * 通用的表单字段校验方法
 * @param name 字段名
 * @param value 字段值
 * @param requiredFields 必填字段数组
 * @param setFormError 设置错误的函数
 */
export const handleFormValidate = <T extends Record<string, any>>(
  name: string,
  value: any,
  requiredFields: string[],
  setFormError: React.Dispatch<React.SetStateAction<any>>
) => {
  if (requiredFields.includes(name)) {
    setFormError((err: any) => ({
      ...err,
      [name]: value ? '' : `${name} required fields!`,
    }));
  }
};

// 可选：导出 requiredFields 的定义（可按需调整）
export const deptRequiredFields = ['pid', 'companyName', 'name'];
export const userRequiredFields = ['username', 'firstName', 'lastName', 'chineseName'];
